export const LANGUAGES = {
	FRENCH: "fr-FR",
	ENGLISH: "en-US",
} as const;

export type LANGUAGE = keyof typeof LANGUAGES;
